export const getters = {
  // До статуса "Одобрено" берем цену продукта из самого продукта.
  // При любом другом статусе она фиксирована в поле unit_price заявки даже если продавец меняет цену в карточке товара
  statusesToShowPriceFromProductInSupplyRequest: () => new Set(['created', 'pending']),
}
